var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay position-fixed w-100 h-100 d-flex align-items-center flex-column justify-content-center"},[_c('div',{staticClass:"kenwood-loader"}),_vm._v(" "),_c('div',{staticClass:"loading-message"},[_c('p',{staticClass:"px-3 text-center px-sm-5 h5"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }